<template>
  <div class="company-icon">
    <v-img :src="url" height="24px" width="24px" />
  </div>
</template>

<script>
export default {
  name: 'CompanyIcon',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>
